import "src/index.css";

import { BrowserRouter, Route, Routes, useParams } from "react-router-dom";

import { InviteLanding } from "src/components/InviteLanding";
import { WaitingScreen } from "src/components/WaitingScreen";
import { useWaitingSSE } from "src/hooks/useWaitingSSE";

function StreamTokenRoute() {
  const params = new URLSearchParams(window.location.search);
  const clientId = params.get("client_id") ?? "";
  const streamToken = params.get("stream_token") ?? "";

  const state = useWaitingSSE(clientId, streamToken);

  return <WaitingScreen clientId={clientId} streamToken={streamToken} state={state} />;
}

function InviteRoute() {
  const { shortCode } = useParams<{ shortCode: string }>();
  return <InviteLanding shortCode={shortCode ?? ""} />;
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<StreamTokenRoute />} />
        <Route path="/i/:shortCode" element={<InviteRoute />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
